module.exports = __webpack_public_path__ + "static/media/facial-initial-page-icon.d1d6764a.svg";